import { Pipe, PipeTransform } from "@angular/core";

import { MarkerIcon } from "../../map.type";

@Pipe({
    name: "googleSize",
})
export class GoogleSizePipe implements PipeTransform {
    public transform(value: MarkerIcon["size"]): google.maps.Size {
        return new google.maps.Size(value.width, value.height);
    }
}
